export default {"src":"/_next/static/media/loopBlue.a1f4d1e0.svg","height":48,"width":49,"blurWidth":0,"blurHeight":0};